import {Injectable} from '@angular/core';
import {LOG_ENTRIES} from '../../../shared/log-helper/log-helper.service';
import {Log} from 'ng2-logger';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

// logger
const log = Log.create(LOG_ENTRIES.drawer_toggle.name);
log.color = LOG_ENTRIES.drawer_toggle.color;

@Injectable()
export class DrawerToggleService {

  // Observable current toggle status
  public drawerToggleStatusSource = new BehaviorSubject<any>(false);

  constructor() {
  }

  public drawerToggleStatus$ = this.drawerToggleStatusSource.asObservable();

  // service message
  updateToggleStatus(status: boolean) {
    this.drawerToggleStatusSource.next(status);
    log.info('update toggle status: ', status);
  }
}



// WEBPACK FOOTER //
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/layout/drawer/drawer-toggle/drawer-toggle.service.ts